import { render } from "./test-free.vue?vue&type=template&id=0b27e3fa&scoped=true"
import script from "./test-free.vue?vue&type=script&lang=js"
export * from "./test-free.vue?vue&type=script&lang=js"

import "./test-free.vue?vue&type=style&index=0&id=0b27e3fa&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b27e3fa"]])

export default __exports__